import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import globalEn from './locales/en/global.json';
import globalRu from './locales/ru/global.json';
import globalDe from './locales/de/global.json';
import globalZh from './locales/zh/global.json';
import mainEn from './locales/en/main.json';
import mainRu from './locales/ru/main.json';
import mainDe from './locales/de/main.json';
import mainZh from './locales/zh/main.json';
import progressEn from './locales/en/progress-cards.json';
import progressRu from './locales/ru/progress-cards.json';
import progressDe from './locales/de/progress-cards.json';
import progressZh from './locales/zh/progress-cards.json';
import aboutEn from './locales/en/about.json';
import aboutRu from './locales/ru/about.json';
import aboutDe from './locales/de/about.json';
import aboutZh from './locales/zh/about.json';
import donateEn from './locales/en/donate.json';
import donateRu from './locales/ru/donate.json';
import donateDe from './locales/de/donate.json';
import donateZh from './locales/zh/donate.json';
import tournamentEn from './locales/en/tournament.json';
import tournamentRu from './locales/ru/tournament.json';
import tournamentDe from './locales/de/tournament.json';
import tournamentZh from './locales/zh/tournament.json';
import authEn from './locales/en/auth.json';
import authRu from './locales/ru/auth.json';
import authDe from './locales/de/auth.json';
import authZh from './locales/zh/auth.json';
import videoEn from './locales/en/video.json';
import videoRu from './locales/ru/video.json';
import videoDe from './locales/de/video.json';
import videoZh from './locales/zh/video.json';
import statisticsEn from './locales/en/statistics.json';
import statisticsRu from './locales/ru/statistics.json';
import statisticsDe from './locales/de/statistics.json';
import statisticsZh from './locales/zh/statistics.json';
import gamesEn from './locales/en/games.json';
import gamesRu from './locales/ru/games.json';
import gamesDe from './locales/de/games.json';
import gamesZh from './locales/zh/games.json';
import adminEn from './locales/en/admin.json';
import adminRu from './locales/ru/admin.json';
import adminDe from './locales/de/admin.json';
import adminZh from './locales/zh/admin.json';
import userEn from './locales/en/user.json';
import userRu from './locales/ru/user.json';
import userDe from './locales/de/user.json';
import userZh from './locales/zh/user.json';
import serverEn from './locales/en/server.json';
import serverRu from './locales/ru/server.json';
import serverDe from './locales/de/server.json';
import serverZh from './locales/zh/server.json';
import clubsRedeemEn from './locales/en/clubs-redeem.json';
import clubsRedeemRu from './locales/ru/clubs-redeem.json';
import clubsRedeemDe from './locales/de/clubs-redeem.json';
import clubsRedeemZh from './locales/zh/clubs-redeem.json';

import { Languages as TLanguages } from '@/shared/types';

const getCookieDomain = () => {
    if (window.location.hostname === 'localhost') {
        return undefined;
    }

    return '.' + window.location.hostname;
};

export const Languages: Record<TLanguages, string> = { en: 'English', ru: 'Русский', de: 'Deutsch', zh: '中文 – 简体' };

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',
        detection: {
            order: ['queryString', 'cookie', 'localStorage', 'navigator'],
            caches: ['cookie'],
            cookieMinutes: 43200,
            cookieDomain: getCookieDomain(),
            convertDetectedLanguage: (lng: string) => lng.split('-')[0],
        },
        supportedLngs: ['en', 'ru', 'de', 'zh'],
        nonExplicitSupportedLngs: true,
        cache: ['cookie'],
        interpolation: {
            escapeValue: false,
        },
        resources: {
            en: {
                global: globalEn,
                main: mainEn,
                progress: progressEn,
                about: aboutEn,
                donate: donateEn,
                tournament: tournamentEn,
                auth: authEn,
                video: videoEn,
                statistics: statisticsEn,
                games: gamesEn,
                admin: adminEn,
                user: userEn,
                server: serverEn,
                'clubs-redeem': clubsRedeemEn,
            },
            ru: {
                global: globalRu,
                main: mainRu,
                progress: progressRu,
                about: aboutRu,
                donate: donateRu,
                tournament: tournamentRu,
                auth: authRu,
                video: videoRu,
                statistics: statisticsRu,
                games: gamesRu,
                admin: adminRu,
                user: userRu,
                server: serverRu,
                'clubs-redeem': clubsRedeemRu,
            },
            de: {
                global: globalDe,
                main: mainDe,
                progress: progressDe,
                about: aboutDe,
                donate: donateDe,
                tournament: tournamentDe,
                auth: authDe,
                video: videoDe,
                statistics: statisticsDe,
                games: gamesDe,
                admin: adminDe,
                user: userDe,
                server: serverDe,
                'clubs-redeem': clubsRedeemDe,
            },
            zh: {
                global: globalZh,
                main: mainZh,
                progress: progressZh,
                about: aboutZh,
                donate: donateZh,
                tournament: tournamentZh,
                auth: authZh,
                video: videoZh,
                statistics: statisticsZh,
                games: gamesZh,
                admin: adminZh,
                user: userZh,
                server: serverZh,
                'clubs-redeem': clubsRedeemZh,
            },
        },
        ns: [
            'global',
            'main',
            'progress',
            'about',
            'donate',
            'tournament',
            'auth',
            'video',
            'statistics',
            'games',
            'admin',
            'user',
            'server',
            'clubs-redeem',
        ],
        defaultNS: 'global',
    });
